import React, { Component } from 'react';
import AccountConfigNotificationPageUI from './AccountConfigNotificationPageUI';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import CacheManager from '../../../cache/CacheManager';
import CacheKeys from '../../../cache/CacheKeys';
import { withRouter } from 'react-router-dom';

class AccountConfigNotificationPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whatsappEnabled: false, // Will be updated from API
      emailEnabled: false,    // Will be updated from API
      loading: true,
      error: null,
      account: null
    };
  }

  handleToggleWhatsapp = () => {
    const { whatsappEnabled, emailEnabled } = this.state;
    this.updateNotificationSettings(!whatsappEnabled, emailEnabled);
  }

  getAccount(context) {
    console.log("this.props", this.props)
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    const account = response.account;
    console.log(account);
    
    // Update state with account data and notification settings from API
    this.setState({
      account: account,
      loading: false,
      whatsappEnabled: account.whatsappEnabled || false,
      emailEnabled: account.emailEnabled || false
    });
  }

  handleToggleEmail = () => {
    const { whatsappEnabled, emailEnabled } = this.state;
    this.updateNotificationSettings(whatsappEnabled, !emailEnabled);
  }

  updateNotificationSettings = (whatsapp, email) => {
    const { match } = this.props;
    const accountId = match.params.accountId;
    this.setState({ loading: true, error: null });
    const url = `/api/su/accounts/enableWhatsEmailNotification/${accountId}?whatsapp=${whatsapp}&email=${email}`;
    RestApiUtils.put(this.props.context, url, (data) => {
      if (!data.success) {
        this.setState({ loading: false, error: data.errorList ? data.errorList.join(', ') : 'Failed to update notification settings' });
        return;
      }
      // Invalidate cache and re-fetch account data
      const cacheKey = CacheKeys.Account(accountId);
      CacheManager.removeObject(cacheKey);
      this.getAccount(this.props.context);
    });
  }

  componentDidMount() {
    let context = this.props.context;
    this.setState({ loading: true });
    this.getAccount(context);
  }

  render() {
    const { whatsappEnabled, emailEnabled, loading, error } = this.state;
    return (
      <AccountConfigNotificationPageUI
        whatsappEnabled={whatsappEnabled}
        emailEnabled={emailEnabled}
        loading={loading}
        error={error}
        onToggleWhatsapp={this.handleToggleWhatsapp}
        onToggleEmail={this.handleToggleEmail}
        context={this.props.context}
        account={this.state.account}
      />
    );
  }
}

export default withRouter(AccountConfigNotificationPageSF);
